export const MARKETING_REQUEST = 'MARKETING_REQUEST';

export const requestMarketing = (operation, args, resolve, reject) => ({
  type: MARKETING_REQUEST,
  operation,
  args,
  resolve,
  reject,
});
